import { NavItemDef } from '../navItems';

export const PERFORMANCE_REPORTING_NAV_ITEMS: NavItemDef[] = [
  // Form Configuration section
  {
    key: 'performanceReporting.divider.formConfiguration',
    label: 'performanceReporting.navItems.dividers.formConfiguration',
    divider: true,
    permissions: ['viewFieldBank', 'viewReviewWorkflow'],
  },
  {
    key: 'performanceReporting.fieldBank',
    label: 'performanceReporting.navItems.fieldBank',
    subtitle: 'performanceReporting.navItems.subtitles.fieldBank',
    path: 'field-bank',
    permissions: ['viewFieldBank'],
    visibility: ({ currentOrganizationId }) => currentOrganizationId === 'lexipoladminstaffuuid',
  },
  {
    key: 'performanceReporting.forms',
    label: 'performanceReporting.navItems.forms',
    subtitle: 'performanceReporting.navItems.subtitles.forms',
    path: 'templates',
    permissions: ['viewFieldBank'],
  },
  {
    key: 'performanceReporting.workflows',
    label: 'performanceReporting.navItems.workflows',
    subtitle: 'performanceReporting.navItems.subtitles.workflows',
    path: 'review-workflows',
    permissions: ['viewReviewWorkflow'],
    visibility: ({ currentOrganizationId }) => currentOrganizationId !== 'lexipoladminstaffuuid',
  },
  // Early Intervention System section
  {
    key: 'performanceReporting.divider.earlyInterventionSystem',
    label: 'performanceReporting.navItems.dividers.earlyInterventionSystem',
    divider: true,
    permissions: ['viewEarlyInterventionSystem'],
    visibility: ({ currentOrganizationId }) => currentOrganizationId !== 'lexipoladminstaffuuid',
  },
  {
    key: 'performanceReporting.thresholds',
    label: 'performanceReporting.navItems.thresholds',
    subtitle: 'performanceReporting.navItems.subtitles.thresholds',
    path: 'early-intervention-system',
    permissions: ['viewEarlyInterventionSystem'],
    visibility: ({ currentOrganizationId }) => currentOrganizationId !== 'lexipoladminstaffuuid',
  },
];
